// extracted by mini-css-extract-plugin
export default {"slider":"Toggle_slider__uFL1+","small":"Toggle_small__ADKem"};